import { render, staticRenderFns } from "./specification.vue?vue&type=template&id=fbb9b590&scoped=true&lang=pug&"
import script from "./specification.vue?vue&type=script&setup=true&lang=js&"
export * from "./specification.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./specification.vue?vue&type=style&index=0&id=fbb9b590&prod&lang=scss&"
import style1 from "./specification.vue?vue&type=style&index=1&id=fbb9b590&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb9b590",
  null
  
)

export default component.exports